export default __webpack_public_path__ + "static/illustration-1-f636ac3db4a0fda6b1f21790e7f5dab9.png";